import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'droid_cookie_consent';

export function getConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

export default function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    window.dispatchEvent(new Event('cookie-consent-changed'));
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
    window.dispatchEvent(new Event('cookie-consent-changed'));
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        transition: 'transform 0.3s ease',
      }}
    >
      <div
        style={{
          maxWidth: 520,
          margin: '0 auto 16px',
          padding: '16px 20px',
          background: 'white',
          borderRadius: 12,
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          border: '1px solid #e5e7eb',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          marginLeft: 16,
          marginRight: 16,
        }}
      >
        <div>
          <p style={{ fontSize: 13, color: '#374151', margin: 0, lineHeight: 1.5 }}>
            {t('shell.cookies.text')}{' '}
            <a
              href="/polityka-prywatnosci"
              style={{ color: '#1D4ED8', textDecoration: 'underline' }}
            >
              {t('shell.cookies.privacyLink')}
            </a>
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={handleReject}
            style={{
              padding: '6px 16px',
              fontSize: 13,
              fontWeight: 500,
              color: '#6b7280',
              background: 'transparent',
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              cursor: 'pointer',
              fontFamily: "'IBM Plex Sans', sans-serif",
            }}
          >
            {t('shell.cookies.reject')}
          </button>
          <button
            onClick={handleAccept}
            style={{
              padding: '6px 16px',
              fontSize: 13,
              fontWeight: 600,
              color: 'white',
              background: '#1D4ED8',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontFamily: "'IBM Plex Sans', sans-serif",
            }}
          >
            {t('shell.cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
